import React from "react";
import List from "../ui/List";

export default function SubmissionList({ reports }) {
  return <List data={reports?.slice(0, 9)} role="directorate-report" />;
}
